module.exports = __webpack_public_path__ + "static/media/sparks.fdd4a624.gif";